var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 4C17.75 3.58579 17.4142 3.25 17 3.25C16.5858 3.25 16.25 3.58579 16.25 4V7.25H13C12.5858 7.25 12.25 7.58579 12.25 8C12.25 8.41421 12.5858 8.75 13 8.75H16.25V12C16.25 12.4142 16.5858 12.75 17 12.75C17.4142 12.75 17.75 12.4142 17.75 12V8.75H21C21.4142 8.75 21.75 8.41421 21.75 8C21.75 7.58579 21.4142 7.25 21 7.25H17.75V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37549 21.2809C11.9057 22.0155 14.6039 21.965 17.111 21.1293L20.8897 19.8697C21.5528 19.6487 22 19.0282 22 18.3293C22 17.2729 21.0073 16.4978 19.9824 16.754L17.6228 17.3439L15.2563 18.2045C14.867 18.346 14.4367 18.1452 14.2952 17.7559C14.1536 17.3667 14.3544 16.9363 14.7437 16.7948L17.1179 15.9314C16.8929 15.26 16.317 14.7191 15.549 14.5911L14.9795 14.4962C13.1183 14.186 11.2132 14.2849 9.39619 14.7844C9.46373 15.011 9.5 15.2511 9.5 15.4996V20.4996C9.5 20.7725 9.45629 21.0351 9.37549 21.2809Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.4996C2 14.9473 2.44772 14.4996 3 14.4996H7C7.55228 14.4996 8 14.9473 8 15.4996V20.4996C8 21.0519 7.55228 21.4996 7 21.4996H3C2.44772 21.4996 2 21.0519 2 20.4996V15.4996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharing);
export default __webpack_public_path__ + "static/media/sharing.e3f046033b1d6b10c9d83922893aed36.svg";
export { ForwardRef as ReactComponent };